import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import App from '../components/App';
import {init as initWebsocket} from '../websocket/client';
// import config from '../config';
import { getNICs, getAbout, getSSHSettings } from '../actions/sysConfigActions';
export default class Root extends Component {
  constructor(props, context) {
    super(props, context);

    this.props.store.dispatch(getNICs(props.hostUrl));
    this.props.store.dispatch(getAbout(props.hostUrl));
    this.props.store.dispatch(getSSHSettings(props.hostUrl));
  }

  render() {
    const { store, history, hostUrl } = this.props;
    initWebsocket(store, hostUrl);
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>

          <App/>

        </ConnectedRouter>
      </Provider>
    );
  }
}
Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};
